import { useEffect } from "react"
import { applyPortalRadius } from "utils/tenantBranding"

/**
 * Favicon + page title for tenant-branded auth pages.
 * @param {boolean} enabled
 * @param {string} title
 * @param {{ logoUrl?: string, appearance?: { borderRadius?: number } }} branding
 */
export default function useTenantAuthChrome(enabled, title, branding) {
  useEffect(() => {
    if (!enabled) return undefined

    const link =
      document.querySelector("link[rel='icon']") ||
      Object.assign(document.createElement("link"), { rel: "icon" })
    if (!link.parentNode) document.head.appendChild(link)

    const prevHref = link.getAttribute("href") || ""
    const prevTitle = document.title
    const logoUrl = typeof branding?.logoUrl === "string" ? branding.logoUrl.trim() : ""

    if (logoUrl) {
      link.href = logoUrl
    }

    document.title = title

    if (branding?.appearance?.borderRadius != null) {
      applyPortalRadius(branding.appearance.borderRadius)
    }

    const metaTheme = document.querySelector("meta[name='theme-color']")
    const prevTheme = metaTheme?.getAttribute("content")
    const themeColor =
      branding?.buttons?.primaryBackgroundColor ||
      branding?.sidebar?.backgroundColor ||
      "#556EE6"
    if (metaTheme) metaTheme.setAttribute("content", themeColor)

    return () => {
      if (prevHref) link.setAttribute("href", prevHref)
      document.title = prevTitle
      if (metaTheme && prevTheme !== undefined) {
        metaTheme.setAttribute("content", prevTheme || "#000000")
      }
    }
  }, [enabled, title, branding])
}
